/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const refreshInputDataSchema = z.object({
	organisationId: z.string().nullable().optional(),
})

export type RefreshInputDataSchema = z.infer<typeof refreshInputDataSchema>
